import { createSlice } from '@reduxjs/toolkit';
import { UserProfile } from 'types/account';

interface IState {
    user?: UserProfile;
    isLoggedIn: boolean;
    previousRoute: string | null;
}

const initialState: IState = {
    isLoggedIn: false,
    previousRoute: null
};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        login(state, action) {
            state.isLoggedIn = true;
            state.user = action.payload;
        },
        logout(state) {
            state.isLoggedIn = false;
            state.user = undefined;
        },
        setPreviousRoute(state, action) {
            state.previousRoute = action.payload || null;
        }
    }
});

export const { login, logout, setPreviousRoute } = accountSlice.actions;

export const selectAccount = (state: any) => state.account;

export default accountSlice.reducer;
